// CustomDialog
import React, { ChangeEvent, useState } from 'react'

import Typography from '@mui/material/Typography'
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import galleryIcon from './../../../assets/icons/upload.png'

import plusIcon from './../../../assets/icons/plus.png'
// import './AddItem.css'

import Cancel from './../../../assets/icons/close.png'

import ChickenIcon from './../../../assets/icons/turkey.png'
import ChickenLegIcon from './../../../assets/icons/chicken-leg.png'
import Burger1Icon from './../../../assets/icons/burger1.png'
import Burger2Icon from './../../../assets/icons/burger.png'
import FullPizzaIcon from './../../../assets/icons/pizza.png'
import pizzaIcon from './../../../assets/icons/pizza (1).png'
import SectionTableSubSection from '../../product/components/SectionTableSubSection.tsx'


interface ImageUploadState {
  // selectedImage: string | null
  selectedImages: string[]
}


const imageMap = [
  { code: 1, icon: ChickenIcon, label: 'Chicken' },
  { code: 2, icon: ChickenLegIcon, label: 'Chicken' },
  { code: 3, icon: Burger1Icon, label: 'Chicken' },
  { code: 4, icon: Burger2Icon, label: 'Chicken' },
  { code: 5, icon: FullPizzaIcon, label: 'Chicken' },
  { code: 6, icon: pizzaIcon, label: 'Chicken' },
]
const imageSectionMap = [
  { codeSection: 1, icon: ChickenIcon, label: 'Chicken' },
  { codeSection: 2, icon: ChickenLegIcon, label: 'Chicken' },
  { codeSection: 3, icon: Burger1Icon, label: 'Chicken' },
  { codeSection: 4, icon: Burger2Icon, label: 'Chicken' },
  { codeSection: 5, icon: FullPizzaIcon, label: 'Chicken' },
  { codeSection: 6, icon: pizzaIcon, label: 'Chicken' },
]

function CustomDialog(props) {
  //   const [value, setValue] = React.useState('1')

  //test start
  const [selectedValue, setSelectedValue] = useState<any>(null)
  const [selectedSectionValue, setSelectedSectionValue] = useState<any>(null)
  const [selectedData, setSelectedData] = useState({})
  const [keyword, setKeyword] = useState(null)


  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value)
  }
  const handleAutocompleteSectionChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedSectionValue(value)
  }
  const handleKeyword = (event) => {
    setKeyword(event.target.value)
  }

  const onClickSave = () => {
    // setSelectedValue(selectedData)
    const Data = {
      Icon: selectedValue,
      Keyword: keyword,
      Section: selectedSectionValue,
    }
    setSelectedData(Data)
    props.onHandleSelectedData(selectedData)
    props.onHandleAddItem(false)
  }

  //test end

  const handleClose = () => {
    props.onClose(false)
  }
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([])



  const addValue = (props) => {
    setAutoCompleteValue(props)
  }

  const renderOption = (option) => (
    <Grid container alignItems="center">
      <Grid item>
        <img src={option.icon} alt="Icon" style={{ width: '1rem' }} />
      </Grid>
      <Grid item>
        <Typography>{option.title}</Typography>
      </Grid>
    </Grid>
  )

  const FoodItem = [
    { code: 1, label: 'Chicken' },
    { code: 2, label: 'Chicken' },
    { code: 3, label: 'Burger' },
    { code: 4, label: 'Burger' },
    { code: 5, label: 'Pizza' },
    { code: 6, label: 'Pizza' },
  ]
  const FoodSectionItem = [
    { codeSection: 1, label: 'Chicken' },
    { codeSection: 2, label: 'Chicken' },
    { codeSection: 3, label: 'Burger' },
    { codeSection: 4, label: 'Burger' },
    { codeSection: 5, label: 'Pizza' },
    { codeSection: 6, label: 'Pizza' },
  ]
  const getFoodSectionImage = (codeSection) => {
    const foundSectionItem = imageSectionMap.find((item) => item.codeSection === codeSection)
    if (foundSectionItem) {
      return foundSectionItem.icon
    }
    return null
  }
  const getFoodImage = (code) => {

    const foundItem = imageMap.find((item) => item.code === code)
    if (foundItem) {
      return foundItem.icon
    }
    return null
  }

  const { open, onClose, dialogType } = props;

  //image upload code start
  // const [openImportSpecification, setopenImportSpecification] = useState(false)



  // const handleopenImportSpecification = () => {
  //   setopenImportSpecification(true)
  // }

  // const handleCloseImportSpecification = () => {
  //   setOpen(false)
  // }
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  })

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files) {
      const imagesArray: string[] = []
      const remainingSlots = 5 - state.selectedImages.length
      const filesToUpload = Array.from(files).slice(0, remainingSlots)
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i]
        const reader = new FileReader()
        reader.onloadend = () => {
          imagesArray.push(reader.result as string)
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray]
            setState({ selectedImages: updatedImages })
          }
        }
        reader.readAsDataURL(file)
      }
    }
  }

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages]
    updatedImages.splice(index, 1)
    setState({ selectedImages: updatedImages })
  }
  //image upload code end




  return (
    <div >
      <React.Fragment>
        <Dialog

          className='addSectionDialog'
          open={props.open}
          onClose={handleClose}
        >
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>{props.dialogTitle}</DialogTitle>
              {/* {dialogType === 'sub' && <DialogTitle>Sub Section</DialogTitle>} */}
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
            <div>
              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: '2rem' }}>
                    Keyword
                  </Typography>
                </Grid>
                <Grid item xs={9}>

                  <TextField
                    label="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: '#371B17' } }}
                  />
                </Grid>
              </Grid>
              {dialogType === 'sub' &&
                <Grid container sx={{ padding: '0.5rem' }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: '1rem' }}>Section</Typography>
                  </Grid>
                  <Grid item xs={9}>


                    <Autocomplete
                      id="country-select-demo"
                      // sx={{ width: 300 }}
                      options={imageSectionMap}
                      value={selectedSectionValue}
                      onChange={handleAutocompleteSectionChange}
                      autoHighlight
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >

                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a section"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                        />
                      )}

                    />
                  </Grid>
                  <Grid item xs={1} className="AddItemplusIcon">
                    <img src={plusIcon} alt="+" />

                  </Grid>
                </Grid>
              }
              {/* <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: '1rem' }}>Icon</Typography>
                </Grid>
                <Grid item xs={9}>
                  

                  <Autocomplete
                    id="country-select-demo"
                   
                    options={imageMap}
                    value={selectedValue}
                    onChange={handleAutocompleteChange}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        <img
                          src={getFoodImage(option.code)}
                          alt=""
                          style={{ width: '2rem' }}
                        />
                        {option.label}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select a icon"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password', 
                        }}
                      />
                    )}
                  
                  />
                </Grid>
                
              </Grid> */}

              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: '0.5rem' }}>
                    Icon
                  </Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    className='uploadButton'

                  // style={{ backgroundColor: '#355ef9', color: 'white', borderRadius:'20px' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                    // style={{ width: '0.8rem', marginRight:'5px' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleImageUpload}
                      disabled={state.selectedImages.length >= 5}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: '0.5rem' }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {state.selectedImages.map((image, index) => (
                        <Grid item xs={2} sm={2} md={2} key={index}>
                          {/* <Paper> */}
                          <div
                            style={{
                              position: 'relative',
                              paddingTop: '20px',
                            }}
                          >

                            <img
                              src={image}
                              alt={`Preview ${index + 1}`}
                              style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'cover',
                              }}
                            />
                            <IconButton
                              style={{
                                position: 'absolute',
                                top: '-6px',
                                right: '-23px',
                                color: 'gray',
                              }}
                              onClick={() => handleDeleteImage(index)}
                            >
                              <CancelIcon />
                            </IconButton>
                          </div>
                          {/* </Paper> */}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>


              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={9}></Grid>

                <Grid item xs={2}>
                  <Button onClick={onClickSave}>
                    Save
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>

                  {dialogType === 'sub' && <SectionTableSubSection selectedValue={selectedData} selectedSectionValue={selectedData} />}
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  )
}

export default CustomDialog
